<template>
  <div class="user">
    <div class="header acea-row">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1">{{ userInfo.nickname }}</div>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>
          </div>
          <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
            ID：{{ userInfo.uid || 0
            }}<span class="iconfont icon-bianji1"></span>
          </router-link>
          <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link>
        </div>
        <span
          class="iconfont icon-shezhi"
          @click="$router.push({ path: '/user/data' })"
        ></span>
      </div>
      <div class="links">
        <router-link :to="'/user/user_coupon'" class="item">
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
          <div>优惠券</div>
        </router-link>
      </div>
    </div>
    <div class="wrapper">
      <!-- <div class="nav acea-row row-middle"> -->
      <!--
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>我的余额</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        -->
      <!--<router-link-->
      <!--:to="'/user/user_promotion'"-->
      <!--class="item"-->
      <!--v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"-->
      <!--&gt;-->
      <!--
        <div
          @click="goPagey('/user/user_promotion')"
          class="item"
          v-if="userInfo.is_promoter === 1 || userInfo.statu === 2"
        >
          <div>当前佣金</div>
          <div class="num">{{ userInfo.brokerage_price || 0 }}</div>
        </div>
        -->
      <!--</router-link>-->
      <!--
        <router-link :to="'/user/integral'" class="item" v-else>
          <div>当前积分</div>
          <div class="num">{{ userInfo.integral || 0 }}</div>
        </router-link>
      -->
      <!-- <router-link :to="'/user/user_coupon'" class="item">
          <div>优惠券</div>
          <div class="num">{{ userInfo.couponCount || 0 }}</div>
        </router-link>
      </div> -->
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/moblie/images/dfk@3x.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unpaid_count > 0"
                >{{ orderStatusNum.unpaid_count }}</span
              >
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 1 }" class="item">
            <div class="pictrue">
              <img src="@assets/moblie/images/dfh@3x.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.unshipped_count > 0"
                >{{ orderStatusNum.unshipped_count }}</span
              >
            </div>
            <div>待发货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 2 }" class="item">
            <div class="pictrue">
              <img src="@assets/moblie/images/dsh@3x.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.received_count > 0"
                >{{ orderStatusNum.received_count }}</span
              >
            </div>
            <div>待收货</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/moblie/images/dpj@3x.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.evaluated_count > 0"
                >{{ orderStatusNum.evaluated_count }}</span
              >
            </div>
            <div>待评价</div>
          </router-link>
          <router-link :to="{ path: `/order/list/-1` }" class="item">
            <div class="pictrue">
              <img src="@assets/moblie/images/daishenhe@3x.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>退款</div>
          </router-link>
          <!-- <router-link :to="'/order/refund_list'" class="item">
            <div class="pictrue">
              <img src="@assets/moblie/images/sh.png" />
              <span
                class="order-status-num"
                v-if="orderStatusNum.refund_count > 0"
                >{{ orderStatusNum.refund_count }}</span
              >
            </div>
            <div>售后/退款</div>
          </router-link> -->
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus">
            <div
              :class="
                item.id == 137 && userInfo.certification_type == 2
                  ? 'item hide'
                  : 'item'
              "
              :key="index"
              @click="goPages(index)"
              v-if="item.wap_url&&item.id!=2096"
            >
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div v-if="item.name!='线下药房'">{{ item.name }}</div>
              <div v-else><span v-if="userInfo.spread_product!='5289'">进口流程</span><span>线下药房</span></div>
            </div>
          </template>
          <!--<div-->
          <!--class="item"-->
          <!--@click="changeswitch(true)"-->
          <!--v-if="userInfo.phone && isWeixin"-->
          <!--&gt;-->
          <!--<div class="pictrue"><img src="@assets/moblie/images/switch.png" /></div>-->
          <!--<div>账号切换</div>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <!--<img src="@assets/moblie/images/support.png" class="support" />-->
    <div class="footer-line-height"></div>
    <SwitchWindow
      v-on:changeswitch="changeswitch"
      :switchActive="switchActive"
      :login_type="userInfo.login_type"
    ></SwitchWindow>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";
import SwitchWindow from "@components/moblie/SwitchWindow";
import GeneralWindow from "@components/moblie/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User(this.$route.query.spread);
    }
  },
  mounted: function() {
    let spread = this.$route.query.spread;
    this.User(spread);
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function(spread) {
      let that = this;
      getUser(spread)
        .then(res => {
          that.userInfo = res.data;
          that.orderStatusNum = res.data.orderStatusNum;
          //console.log(this.orderStatusNum);
          this.generalContent = {
            promoterNum: `您在商城累计消费金额仅差 <span style="color: #ee5a52;">${res
              .data.promoter_price || 0}元</span>即可开通推广权限`,
            title: "您未获得推广权限"
          };
          this.MenuUser();
        })
        .catch(e => {
          console.log(e);
        });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser()
        .then(res => {
          that.MyMenus = res.data.routine_my_menus;
        })
        .catch(e => {
          console.log(e);
        });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPages: function(index) {
      if (this.MyMenus[index].name === "联系客服") {
         return (window.location.href = `https://work.weixin.qq.com/kfid/kfc17fdc05b8b6141ec`);
      }
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (
          !this.userInfo.is_promoter &&
          this.userInfo.certification_type == 2
        ) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: rgb(102, 129, 244);
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid rgb(102, 129, 244);
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 50px;
  font-size: 0.14rem;
  border: 1px solid #e8695e;
  color: #ffffff;
}
.hide {
  display: none;
}
</style>
